import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@app/core/services/auth.service';

@Injectable()
export class GuestGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!this.authService.hasToken()) return true;

    // Don't redirect to state.url here, because it's equal to the *target* URL
    // when the page is first loaded, causing infinite redirection to the same url.
    this.router.navigate(['/']);
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/guest-guard.service.ts